import type { ReactNode } from 'react';
import {
  PageContent,
  PageHeaderRoot,
  PageTitle,
  PageSubtitle,
  PageActions,
} from './PageLayout.styled';

export { PageContent, PageTitle, PageSubtitle, PageActions };

interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <PageHeaderRoot>
      <div>
        {typeof title === 'string' ? <PageTitle>{title}</PageTitle> : title}
        {subtitle ? (
          typeof subtitle === 'string' ? <PageSubtitle>{subtitle}</PageSubtitle> : subtitle
        ) : null}
      </div>
      {actions ? <PageActions>{actions}</PageActions> : null}
    </PageHeaderRoot>
  );
}
